import React from 'react';
import { Box, Divider } from 'vindi-ds-components';

import useToggle from '@hooks/feature_toggles';

import HeaderChargesPending from './components/header';
import ListChargesPending from './components/list';

function ChargesPending() {
  const toggle = useToggle('new_ds_charges_pending');

  if (!toggle) { return null; }

  return (
    <Box mb={10}>
      <HeaderChargesPending />

      <Divider />

      <ListChargesPending />
    </Box>
  );
}

export default ChargesPending;
